module.exports = __webpack_public_path__ + "img/guatemala.4766b57d.svg";